import { interact, URLS } from "fire-wind-water";
import { settings, wd } from "../../common/setting";
import { scmsService } from "../../services/site";

const config = wd.stemplateConfig || {};

export function isLink(): void {
  const href: string = window.location.href;
  // let link = "";
  const siteReg = /site\/(\w+)\//;
  let sitePath: any = href.match(siteReg);
  if (sitePath) {
    sitePath = sitePath[1];
  }
  if (settings.isNotLink === 1) {
    return;
  }
  // if (config.link && config.link.pc && config.link.wap) {
  //   if (
  //     interact.isMobile === 1 ||
  //     navigator.userAgent.toLocaleLowerCase().indexOf("miniprogram") > -1
  //   ) {
  //     // 微信小程序webview环境
  //     link = config.link.wap;
  //   } else {
  //     link = config.link.pc;
  //   }
  // }
  // if (link && link.indexOf(sitePath) === -1) {
  //   window.location.href = link + window.location.search;
  // }
  // 正式链接用预览链接后，做修改
  const param = {
    tenantId: settings.tenantId || URLS.getURL("tid") || (window['siteParams']?window['siteParams'].tid:null),
    siteId: settings.siteId,
  };
  scmsService.getTempUrl(param).subscribe((res) => {
    if (res && res.result === 0) {
      if (settings.isPreview && !URLS.getURL("preview")) {
        // 正式访问地址，自适应链接
        if (
          interact.isMobile === 1 ||
          navigator.userAgent.toLocaleLowerCase().indexOf("miniprogram") > -1
        ) {
          // 微信小程序webview环境
          const href = window.location.href;
          if (href.indexOf("/pc/") > -1) {
            window.location.href = res.content.wap_longurl;
          }
        } else {
          if (href.indexOf("/wap/") > -1) {
            window.location.href = res.content.pc_longurl;
          }
        }
      }
      settings.thirdCode = res.content.third_code; // 埋码
      // 页面标题
      settings.pcTitle = res.content.seo_title_pc;
      settings.wapTitle = res.content.seo_title_wap;
      // 首页地址
      settings.pcLongUrl = res.content.pc_longurl;
      settings.wapLongUrl = res.content.wap_longurl;
      document.title =
        settings.category === "1" ? settings.pcTitle : settings.wapTitle;
      // 页面icon
      const link: any = document.querySelector("link[rel~='icon']");
      if (link) {
        link.href = res.content.site_favicon;
      }
      // 页面keywords/ desc
      const keyMeta = document.querySelector("meta[name='keywords']");
      if (keyMeta) {
        keyMeta.setAttribute("content", res.content.seo_keyword);
      }
      const descMeta = document.querySelector("meta[name='description']");
      if (descMeta) {
        descMeta.setAttribute("content", res.content.seo_describe);
      }
      // 分享配置的值
      (window as any).stemplateConfig.tenantId = res.content.tenantId;
      (window as any).stemplateConfig.shareTitle = res.content.shareTitle;
      (window as any).stemplateConfig.shareDesc = res.content.shareDesc;
      (window as any).stemplateConfig.shareCoverUrl = res.content.shareCoverUrl;
      (window as any).stemplateConfig.shareCover = res.content.shareCover;
      (window as any).stemplateConfig.instanceId = res.content.instanceId;
    }
  });
}
